import { Box, Text } from '@nimbus-ds/components';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';

interface DaysProgressBarProps {
  totalDays: number;
  daysLeft: number;
}

export default function DaysProgressBar({
  totalDays,
  daysLeft,
}: Readonly<DaysProgressBarProps>) {
  const t = useTranslationDashboard();
  const percent = Math.max(
    0,
    Math.min(100, ((totalDays - daysLeft) / totalDays) * 100),
  );
  return (
    <Box paddingBottom="2" paddingTop="2">
      <Text color="danger-interactive">
        {t('cloudflareBlock.daysLeft', { count: daysLeft })}
      </Text>
      <Box
        width="100%"
        height="8px"
        backgroundColor="neutral-surfaceHighlight"
        borderRadius="base"
        overflow="hidden"
      >
        <Box
          height="100%"
          width={`${percent}%`}
          backgroundColor="danger-interactive"
        />
      </Box>
    </Box>
  );
}
